<template>
  <Loader v-if="loading"> </Loader>
  <div class="full-width-container">
    <!-- Prima Card - Caricamento File -->
    <div class="center-content">
      <Card class="w-full">
        <template v-slot:content>
          <h1 class="page-title">Caricamento File RCU</h1>
          <div class="flex align-items-center flex-column w-full">
            <div class="button-wrapper mb-2">
              <span class="label">{{
                fileToUpload.length == 0
                  ? "Seleziona File"
                  : fileToUpload.length + " files"
              }}</span>
              <input 
                id="upload" 
                type="file" 
                ref="file" 
                @change="handleFileUpload($event)"
                accept="application/zip,application/x-zip-compressed" 
                multiple 
              />
            </div>
            <div v-show="validationErrors.files && submitted" class="p-error">
              Campo richiesto.
            </div>
            <div v-show="validationErrors.type && submitted" class="p-error">
              Formato non consentito
            </div>
          </div>
          <div class="text-center">
            <small>Formati consentiti: {{ allowedType.join(", ") }}</small>
          </div>
          <Button @click="uploadFileRcuOnFtp" class="upload-button"> <span>Carica file</span>
                        <i class="pi pi-upload"></i>
                      </Button>
        </template>
      </Card>
    </div>
  </div>
  <div class="center-content">
    <Card class="history-card">
      <template v-slot:header>
        <br />
        <h3 class="page-title">Storico File Caricati</h3>
      </template>
      <template v-slot:content>
        <div>
          <input type="text" v-model="searchQuery" placeholder="Cerca file..." class="file-search-input" />
        </div>
        <table class="file-table">
          <thead>
            <tr>
              <th>File</th>
              <th>Data di caricamento</th>
              <th>Utente</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in uploadedFiles" :key="file.file_name">
              <td>{{ file.file_name }}</td>
              <td>{{ file.created_at }}</td>
              <td>
                <span class="email">{{ file.email }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="file-count-select-wrapper">
          <select id="fileCount" v-model="filesPerPage" class="file-count-select">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </template>
    </Card>
  </div>
  <div class="center-content">
    <Card class="history-card">
      <template v-slot:header>
  <br />
  <h3 class="page-title">Storico Elaborazione File</h3>
</template>
<template v-slot:content>
  <table class="file-table">
    <thead>
      <tr>
        <th>Id</th>
        <th>operation</th>
        <th>created_at</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in logMessages" :key="item.id">
        <td>{{ item.id }}</td>
        <td>{{ item.operation }}</td>
        <td>{{ moment(item.created_at).format('DD-MM-YYYY') }}</td>
      </tr>
    </tbody>
  </table>
</template>
    </Card>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";
import { useStore } from "vuex";
import Service from "@/services/ask-caricamento-file/caricamento-file";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import axios from "axios";

export default {
  components: {
    Loader,
  },

  setup() {
    const store = useStore();
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const fileToUpload = ref([]);
    const currentUser = ref(store.state.auth.user);
    const allowedType = ["zip", "x-zip-compressed"];
    const validationErrors = ref({});
    const submitted = ref(false);
    const loading = ref(false);
    const uploadedFiles = ref([]);
    const currentPage = ref(1);
    const filesPerPage = ref(10);
    const searchQuery = ref("");
    const countFileElaborati = ref(null);
    const logMessages = ref([]);

    const filteredFiles = computed(() => {
      return uploadedFiles.value.filter((file) => {
        return file.name
          .toLowerCase()
          .includes(searchQuery.value.toLowerCase());
      });
    });

    const paginatedFiles = computed(() => {
      const startIndex = (currentPage.value - 1) * filesPerPage.value;
      const endIndex = startIndex + filesPerPage.value;
      return uploadedFiles.value.slice(startIndex, endIndex);
    });

    const handleFileUpload = (evt) => {
      evt.preventDefault();
      submitted.value = false;
      fileToUpload.value = self.refs.file.files;
    };

    const uploadFileRcuOnFtp = () => {
      submitted.value = true;
      if (validateForm()) {
        loading.value = true;

        service
          .uploadFileRcuOnFtp(fileToUpload.value)
          .then((response) => {
            const uploaded = response.files;

            uploaded.forEach((file) => {
              file.uploader = currentUser.value;
            });

            uploadedFiles.value = [...uploadedFiles.value, ...uploaded];

            const message =
              response.message || "File Caricati con successo";
            toast.add({
              severity: "success",
              summary: "Successo",
              detail: message,
              life: 5000,
            });
            fetchUploadedFiles();
          })
          .catch((error) => {
            toast.add({
              severity: "success",
              summary: "Successo",
              detail: "File Caricati con successo",
            });
          })
          .finally(() => {
            loading.value = false;
          });
      }
    };

    const getLogsFileElaborazioneAskFileRcu = async () => {
      loading.value = true;

      service
        .getLogsFileElaborazioneAskFile("process-rcu")
        .then((res) => {
          logMessages.value = res.items;
          console.log(logMessages.value);
        })
        .catch((err) => { })
        .finally(() => {
          loading.value = false;
        });
    };

    const fetchUploadedFiles = async () => {
      try {
        const filesResponse = await service.getAllUploadedFilesRcu();
        const formattedFiles = filesResponse.map((file) => {
          return {
            ...file,
            created_at: moment(file.created_at).format("YYYY-MM-DD HH:mm:ss"),
          };
        });
        uploadedFiles.value = formattedFiles;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il recupero dei file",
        });
      }
    };

    fetchUploadedFiles();
    onMounted(fetchUploadedFiles);
    onMounted(getLogsFileElaborazioneAskFileRcu);

    const validateForm = () => {
      console.log(fileToUpload.value);
      if (fileToUpload.value.length == 0) {
        validationErrors.value["files"] = true;
        delete validationErrors.value["type"];
      } else {
        delete validationErrors.value["files"];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(
          (file) => allowedType.includes(file.type.replace(/(.*)\//g, "")),
          false
        );
        if (valid) delete validationErrors.value["type"];
        else validationErrors.value["type"] = true;
      }

      return !Object.keys(validationErrors.value).length;
    };

    return {
      moment,
      store,
      validationErrors,
      submitted,
      service,
      fileToUpload,
      handleFileUpload,
      allowedType,
      uploadFileRcuOnFtp,
      uploadedFiles,
      loading,
      fetchUploadedFiles,
      logMessages,
      countFileElaborati,
      getLogsFileElaborazioneAskFileRcu,
      currentUser,
      currentPage,
      filesPerPage,
      paginatedFiles,
      searchQuery,
      filteredFiles,
    };
  },
};
</script>

<style>
.button-wrapper {
  position: relative;
  width: 100% !important;
  max-width: 600px;
  height: 180px;
  margin: 10px auto;
  border: 1px dashed #007BFF;
  border-radius: 12px;
  background: #f9f9f9;
  transition: all 0.3s ease;
  color:#544848;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 1.5rem;
  text-align: center;
  overflow: hidden;
  font-weight: bold;
}

.button-wrapper:hover {
  border-color: #0056b3;
  background: #eef7ff;
  transform: scale(1.02);
}

.button-wrapper.has-files {
  border-style: solid;
  background: #f1f8e9;
}

.button-wrapper span.label {
  font-size: 1rem;
  background-color: #1a61b6 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
}

.button-wrapper span.label::before {
  content: '📂';
  font-size: 3rem;
  color: #544848;
}

.button-wrapper.has-files span.label::before {
  content: '✅';
  color: #28a745;
}

.upload-button {
  display: block;
  width: 100% !important;
  max-width: 400px;
  height: 40px;
  margin: 20px auto;
  border-radius: 12px;
  font-size: 1.2rem;
  background: #315B8E;
  color: white;
  font-weight: bold;
  transition: all 0.3s ease;
}

.upload-button:hover {
  background: #0056b3;
  transform: scale(1.02);
}

#upload {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 10000;
  display: block;
}

.history-card {
  margin-top: 20px;
}

.page-title {
    text-align: center;
    margin: 10px 0 20px 0;
    font-size: 30px;
    color: var(--text-primary);
    font-weight: 600;
    padding-bottom: 10px;
    border-bottom: 2px solid var(--border-color);
}
.file-table {
  width: 100%;
  border-collapse: collapse;
}

.file-table th, 
.file-table td,
.file-table .p-datatable-thead th,
.file-table .p-datatable-tbody td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.file-table th,
.file-table .p-datatable-thead th {
  background: #4b93bf !important;
  font-weight: bold;
  color: white !important;
  height: 50px !important;
}

.file-table.p-datatable .p-datatable-thead > tr > th {
  background: #4b93bf !important;
  color: white !important;
  height: 50px !important;
  padding: 5px;
  text-align: left;

}

.file-table.p-datatable .p-datatable-tbody > tr > td {
  padding: 8px;
  text-align: left;
  color: black !important;
}


.custom-select {
  position: relative;
  display: inline-block;
  width: 140px;
}


.file-count-select {
  width: 100%;
  padding: 10px;
  padding-right: 30px;
  font-size: 1rem;
  border: 2px solid #4b93bf;
  border-radius: 8px;
  background-color: #ffffff;
  appearance: none;
  cursor: pointer;
  transition: 0.3s ease;
}


.select-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #4b93bf;
  font-size: 1rem;
}

.file-count-select:focus {
  border-color: #3278a6;
  box-shadow: 0 0 5px rgba(75, 147, 191, 0.5);
  outline: none;
}


.file-count-select option {
  background-color: #ffffff;
  color: #333;
  padding: 10px;
  font-size: 1rem;
  border-radius: 5px;
}

.file-count-select option:hover {
  background-color: #4b93bf;
  color: white;
}

.file-search-input {
  margin-top: 5px;
  margin-bottom: 10px;
  width: 10%;
  padding: 8px;
  border: 1px solid #b6b6b6 !important;
  border-radius: 5px;
  box-sizing: border-box;
}

.file-search-input:focus {
  border-color: #4b93bf !important;
  box-shadow: 0 0 5px rgba(75, 147, 191, 0.5);
  outline: none;
}
</style>
